import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '='
    },
    template: `
            <div class="well color02">
                <div class="heading01">
                    <h1>{{ 'course.Occurrences' | translate }}</h1>
                    <ul class="actions01">
                        <li>
                            <label class="switch01 visible-label">
                                <input ng-disabled="!vm.canManageCourses || vm.loading || vm.course.isArchived"
                                    ng-click="vm.save()" ng-model="vm.course.isDirectManagerPlanningEnabled" type="checkbox">
                                <span>{{ 'course.Enable direct manager planning' | translate }}</span>
                                <span class="tooltip-icon"
                                    tooltip-append-to-body="true"
                                    uib-tooltip="{{ 'course.Allow direct manager to enroll employees to this course' | translate }}"
                                    tooltip-placement="top-right">?</span>
                            </label>
                        </li>
                        <li>
                            <a ng-if="vm.hasOccurrences" class="btn filter" ng-click="vm.showFilter = !vm.showFilter">{{ 'filter.Filter occurrences' | translate }}</a>
                        </li>
                        <li>
                            <a ng-if="vm.canManageOccurrences && vm.isVersionLoaded && !vm.course.isArchived"
                               class="btn add" ui-sref="authorized.courses.courses.edit.occurrence.add.general({ id: vm.$state.params.id })">
                                {{ 'course.Plan course' | translate }}
                            </a>
                        </li>
                    </ul>
                </div>
                <courses-courses-edit-occurrence-filter
                    list="vm.list"
                    sites="vm.sites"
                    default-filter="vm.defaultFilter"
                    filter="vm.filter"
                    versions="vm.versions"
                    ng-if="vm.showFilter && vm.versions"
                />
                <p class="desc muted" ng-if="!vm.list.loading && vm.isVersionLoaded && !vm.defaultQueryOccurrences.length">
                    {{ 'course.occurrence notification 1.1' | translate }} <b>{{ 'course.occurrence notification 1.2' | translate }}</b> {{ 'course.occurrence notification 1.3' | translate }}
                    <a ng-click="vm.openPlanningNeedsDeadlineModal(vm.$state.params.id)"><b>{{ 'course.occurrence notification 2' | translate }}</b></a>
                </p>
                <p class="desc muted" ng-if="!vm.list.loading && vm.isVersionLoaded && vm.defaultQueryOccurrences.length">
                    {{ 'course.occurrence notification 4' | translate }}
                </p>
                <list-factory-empty ng-if="vm.isVersionLoaded" list="vm.list" show-add-message="true"></list-factory-empty>
                <div class="tablewrapper">
                    <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="!vm.list.loading && vm.list.items.length">
                        <thead>
                            <tr>
                                <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'course.Name' | translate }}</a></th>
                                <th>{{ 'course.Version' | translate }}</th>
                                <th>{{ 'course.Site' | translate }}</th>
                                <th ng-class="vm.list.getSortClass('status')"><a ng-click="vm.list.sortBy('status')">{{ 'course.Status' | translate }}</th>
                                <th class="actions">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr ng-repeat="item in vm.list.items">
                                <td>{{ item.name }}</td>
                                <td>{{ item.courseVersion.name }}</td>
                                <td ng-if="item.sites.length">{{ vm.getSites(item.sites) }}</td>
                                <td ng-if="!item.sites.length">
                                    {{ vm.allSitesMessage }}
                                    </br>
                                    <small ng-if="item.isExternalSiteUserExcluded">({{ 'planningGroup.External site excluded' | translate }})</small>
                                </td>
                                <td>{{ vm.OCCURRENCE_STATUS_ENUM.LABELS[item.status] }}</td>
                                <td class="actions">
                                    <a class="btn edit" ui-sref="authorized.courses.courses.edit.occurrence.edit.general({ id: vm.$state.params.id, occurrenceId: item.id})">
                                        <span ng-if="vm.canManageOccurrences">{{ 'general.Edit' | translate }}</span>
                                        <span ng-if="!vm.canManageOccurrences">{{ 'general.View' | translate }}</span>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination list="vm.list"></pagination>
                </div>
            </div>
            <courses-courses-edit-occurrence-automated-planning-group-list
                ng-if="vm.canViewAutomatedPlanningGroups"
                course-id="vm.$state.params.id"
                course="vm.course">
            </courses-courses-edit-occurrence-automated-planning-group-list>
    `
})

export default class {
    constructor ($state, $translate, $sce, DATATABLES, OCCURRENCE_STATUS_ENUM, ListFactory, lodash,
                 OccurrenceResource, CourseVersionResource, ModalService, PrivilegeService, toastr,
                 FORMS_SITE_ACCESS_ENUM, ROLE_PRIVILEGE_ENUM, SiteService, CourseResource) {
        this.$translate = $translate;
        this.$sce = $sce;
        this.lodash = lodash;
        this.toastr = toastr;
        this.DATATABLES = DATATABLES;
        this.OCCURRENCE_STATUS_ENUM = OCCURRENCE_STATUS_ENUM;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
        this.CourseVersionResource = CourseVersionResource;
        this.CourseResource = CourseResource;
        this.$state = $state;
        this.ListFactory = ListFactory;
        this.OccurrenceResource = OccurrenceResource;
        this.hasOccurrences = false;
        this.FORMS_SITE_ACCESS_ENUM = FORMS_SITE_ACCESS_ENUM;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
        this.SiteService = SiteService;
    }

    $onInit () {
        this.sites = this.SiteService.getSitesByPrivileges([
            this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_VIEW_AND_OCCURRENCE_MANAGE,
            this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_MANAGE,
            this.ROLE_PRIVILEGE_ENUM.KEYS.COURSE_ADMINISTRATE
        ]);
        this.defaultFilter = {
            courseId: this.$state.params.id,
            siteIds: this.sites.map(site => site.id)
        };
        this.filter = angular.copy(this.defaultFilter);
        this.defaultQueryOccurrences = [];
        this.list = this.ListFactory.createWithPagination(
            this.OccurrenceResource.getOccurrences.bind(this.OccurrenceResource)
        );
        this.list.fetch({ expand: 'courseVersion,site,courseOccurrenceTrainings,sites' }, this.defaultFilter).then((occurrences) => {
            this.defaultQueryOccurrences = occurrences;
        });

        // Default filter toggles includeFinishedOccurrences to false, so we need to be sure, there is at least one occurrence
        // even if it is finished one. That way we prevent filter to get hidden, if all occurrences are finished.
        this.OccurrenceResource.query({
            courseId: this.$state.params.id,
            includeFinishedOccurrences: true,
            pageSize: 1,
            expand: 'sites'
        }).$promise.then(occurrence => {
            if (occurrence) {
                this.hasOccurrences = true;
            }
        });

        this.canManageOccurrences = this.PrivilegeService.canManageOccurrences();
        this.canViewAutomatedPlanningGroups = this.PrivilegeService.canViewAutomatedPlanningGroups();
        this.canManageCourses = this.PrivilegeService.canManageCourses();
        this.allSitesMessage = this.$translate.instant('course.All sites');
        this.isVersionLoaded = false;
        this.hasWithoutPlanningVersionsOnly = true;

        // By default only WITH planning versions are queried
        this.CourseVersionResource.query({ courseId: this.$state.params.id, pageSize: 0 }).$promise.then((versions) => {
            this.versions = versions;
            this.isVersionLoaded = true;
        });

        this.loading = false;
    }

    getSites (sites) {
        return sites.map(site => site.name).join(', ');
    }

    openPlanningNeedsDeadlineModal (courseId) {
        return this.ModalService.open({
            template: '<modals-planning-needs-deadline course-id="vm.courseId" class="wrapper" cancel="vm.$uibModalInstance.dismiss()" update="vm.update()"/>',
            controller ($uibModalInstance) {
                this.courseId = courseId;
                this.$uibModalInstance = $uibModalInstance;
                this.update = () => {
                    this.$uibModalInstance.close();
                };
            },
            size: 'large'
        });
    }

    save () {
        const clonedCourse = this.lodash.clone(this.course);
        this.loading = true;
        clonedCourse.fields = clonedCourse.courseFields.map((field) => (field.fieldId));
        clonedCourse.courseSiteIds = clonedCourse.sites.map(site => (site.id));
        delete clonedCourse.courseVersions;
        if (clonedCourse.expirationMonths === null) {
            clonedCourse.expirationMonths = 0;
        }
        this.CourseResource.update({
            id: this.course.id, expand:
            'fields,courseFields,courseTrainings,courseTrainingsActiveI18n,activeI18n,courseI18ns,courseTrainingI18ns,courseVersions'
        + ',courseVersions,courseTrainingForms,sites,company,event,connectedEvents.templates.times,courseTrainings.scormTrainings'
        + ',courseVersions.courseTrainings.courseTrainingI18ns,courseVersions.courseTrainings.materials'
        + ',courseVersions.courseTrainings.materials.languages,courseVersions.courseTrainings.materials.chapters.chapterI18ns'
        + ',courseVersions.courseTrainings.materials.chapters.section.sectionI18ns,courseVersions.courseTrainings.scormTrainings'
        }, clonedCourse).$promise.then((course) => {
            this.course = course;
            this.toastr.success(this.$translate.instant('general.Changes saved'));
            this.loading = false;
        }).catch(() => {
            this.course.isDirectManagerPlanningEnabled = !this.course.isDirectManagerPlanningEnabled;
            this.toastr.error(this.$translate.instant('general.Something went wrong'));
            this.loading = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/list/index.js